// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"a6ace560","321":"dd5e07a3","816":"529eef2d","955":"dd5e07a3"}[chunkId] + ".chunk.css";
};